import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated } from "@/lib/apiClient";

const RequireAuth = ({ children }) => {
  const location = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to="/cms/login" state={{ from: location }} replace />;
  }

  return children;
};

export default RequireAuth;
